(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './relation'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./relation'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.relation);
    global.checkbox = mod.exports;
  }
})(this, function (exports, _relation) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CheckboxMixin = undefined;

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var CheckboxMixin = exports.CheckboxMixin = function CheckboxMixin(_ref) {
    var parent = _ref.parent,
        role = _ref.role;
    return {
      mixins: [(0, _relation.ChildrenMixin)(parent)],

      props: {
        name: null,
        value: null,
        disabled: Boolean,
        labelDisabled: Boolean,
        labelPosition: {
          type: String,
          default: 'left',
          validator: function validator(value) {
            return ['left', 'right'].indexOf(value) > -1;
          }
        },
        iconAlign: {
          type: String,
          default: ''
        }
      },

      data: function data() {
        return {
          animation: false
        };
      },


      computed: {
        isDisabled: function isDisabled() {
          return this.parent && this.parent.disabled || this.disabled;
        },
        radioClass: function radioClass() {
          return _defineProperty({}, 'nx-' + role + '-right', this.labelPosition === 'right');
        },
        labelClass: function labelClass() {
          return _defineProperty({}, 'nx-' + role + '__label-disabled', this.labelDisabled);
        },
        iconClass: function iconClass() {
          var _ref4;

          return _ref4 = {}, _defineProperty(_ref4, 'nx-' + role + '__icon-disabled', this.isDisabled), _defineProperty(_ref4, 'nx-' + role + '__icon-checked', this.checked), _defineProperty(_ref4, 'nx-' + role + '__icon-animation', this.animation), _defineProperty(_ref4, 'nx-' + role + '__icon-top', this.iconAlign === 'top'), _ref4;
        }
      },

      mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
          var icon = _this.$refs.icon;

          icon && icon.addEventListener('animationend', function () {
            if (role == 'radio') {
              return;
            }
            _this.animation = false;
          });
        });
      },


      methods: {
        onClick: function onClick(event) {
          var label = this.$refs.label;
          var target = event.target;

          var labelClicked = label && (label === target || label.contains(target));

          if (!this.isDisabled && !(labelClicked && this.labelDisabled)) {
            this.toggle();
          }

          this.$emit('click', event);
        }
      }
    };
  };
});